import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';

export const AccordionTrigger = React.forwardRef(
  ({ children, ...props }, forwardedRef) => (
    <Accordion.Header className='accordion__trigger'>
      <Accordion.Trigger
        {...props}
        ref={forwardedRef}
        className='accordion__trigger'
      >
        {children}
        <i className="fa fa-chevron-down accordion__chevron" />
      </Accordion.Trigger>
    </Accordion.Header>
  )
);

export const AccordionContent = React.forwardRef(
  ({ children, ...props }, forwardedRef) => (
    <Accordion.Content
      {...props}
      className="accordion__content"
      ref={forwardedRef}
    >
      <div>{children}</div>
    </Accordion.Content>
  )
);
